/**
 * Monkey-patches the global `fetch` so that any 429 response
 * automatically triggers a toast notification.
 *
 * Mount this component once inside a `<ToastProvider>`.
 */

import { useToastContext } from "@/components/ui/Toast";
import { t } from "@/i18n";
import { useEffect } from "react";

export function RateLimitInterceptor() {
  const { show } = useToastContext();

  useEffect(() => {
    const original = window.fetch;

    window.fetch = async (...args: Parameters<typeof fetch>) => {
      const res = await original(...args);

      if (res.status === 429) {
        const retryAfter = res.headers.get("Retry-After");
        const msg = retryAfter
          ? `${t("rateLimit.slowDown")} — retry in ${retryAfter}s`
          : t("rateLimit.slowDown");
        show(msg, "error");
      }

      return res;
    };

    return () => {
      window.fetch = original;
    };
  }, [show]);

  return null;
}
